// extracted by mini-css-extract-plugin
export var quillEditor = "_mq-1";
export var variable = "_mq-0";